/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { UserContext } from '@gh/common-shared';
import { ID, UserData } from '@gh/common-shared-data';

export interface OfficeInfo {
  id: ID;
  name: string;
  description: string;
  phone: string;
}

export type SupplierUserData = UserData & { receiveEmails: boolean };

export abstract class SupplierUserContext extends UserContext {
  abstract readonly currentOffice: OfficeInfo;
  abstract readonly offices: OfficeInfo[];

  abstract getOffice(id: ID): Maybe<OfficeInfo>;

  abstract setCurrentOffice(id: ID): void;

  abstract isOfficeExist(id: ID): boolean;

  abstract updateReceiveEmails(receiveEmails: boolean): void;
}
